module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/118.a37b2e53.png";